// component
import TransactionList from './transaction-list/transaction-list.vue';
import TransactionDetail from './transaction-list-detail/transaction-list-detail.vue';
import SignUp from './sign-up/sign-up.vue';
// import TranSandle from './trans-handle/trans-handle.vue';

export default [
  {
    path: 'list',
    name: 'transactionList',
    component: TransactionList,
    meta: {
      title: '交易项目'
      // breadCrumbShowIndexArr: [0, 2] 隐藏面包屑
    }
  },
  {
    path: 'detail',
    name: 'transactionDetail',
    component: TransactionDetail,
    meta: {
      title: '交易项目详情'
      // breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'signup',
    name: 'signup',
    component: SignUp,
    meta: {
      title: '整体报名'
      // breadCrumbShowIndexArr: [0, 2]
    }
  }
  // {
  //   path: 'transandle',
  //   name: 'transandle',
  //   component: TranSandle,
  //   meta: {
  //     title: '处理'
  //     // breadCrumbShowIndexArr: [0, 2]
  //   }
  // }
];
